module.exports = __webpack_public_path__ + "img/banne03_logo.f4695bcd.png";